import Api from "../../../util/Api";

export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        logGridIsOpen: false,
        dataTableOptions: {
            server_mode: true,
            global_search: {
                visibility: false,
            }
        },

        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új XLS feltöltése',
                event_name: "customClick",
                class: "btn btn-success",
                event_payload: 'newRow'
            },
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            }
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning mx-1",
                event_payload: 'backToGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary mx-1",
                event_payload: 'resetForm'
            },
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-check"></i>',
                event_name: "customClick",
                title: "Adatellenőrzés",
                class: "btn btn-outline-info",
                event_payload: 'validateXls',
                additionalButtonVisible: 'xlsImportValidateXlsButtonVisible'
            },
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyXls',
                additionalButtonVisible: 'xlsImportModifyXlsButtonVisible'
            },
            {
                btn_text: '<i class="fas fa-file-import"></i>',
                event_name: "customClick",
                title: "Betöltés",
                class: "btn btn-outline-success",
                event_payload: 'importXls',
                additionalButtonVisible: 'xlsImportImportXlsButtonVisible'
            },
            {
                btn_text: '<i class="fas fa-align-justify"></i>',
                title: "Log megtekintése",
                event_name: "customClick",
                class: "btn btn-outline-warning",
                event_payload: 'showLoaderLog',
                additionalButtonVisible: 'xlsImportShowXlsLogButtonVisible'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: "Visszavonás",
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'rollbackXls',
                additionalButtonVisible: 'xlsImportRollbackXlsButtonVisible'
            }
        ],
        searchFields: [
            {
                name: "fileName",
                label: "Fájl név",
                formType: "text",
                formVisible: true,
                formSize: 4
            },
            {
                name: "statusId",
                label: "Státusz",
                formSize: 4,
                formType: "select",
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getXlsImportStatusList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false
            },
            {
                name: "fileName",
                label: "Fájl név",
                sort: true,
                visibility: true
            },
            {
                name: "loaderTypeId",
                label: "Betöltő",
                visibility: false,
                formVisible: true,
                formRequired: true,
                formSize: 4,
                formType: "select",
                selectOptions: {
                    externalOptionList: [
                        {id: 47101, text: 'Korlátozás'},
                        {id: 47102, text: 'Védőoltás'},
                    ],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "status.text",
                label: "Státusz",
                sort: true,
                visibility: true
            },
            {
                name: "loaderType.text",
                label: "Típus",
                sort: true,
                visibility: true
            },
            {
                name: "createdBy",
                label: "Feltöltötte",
                visibility: true
            },
            {
                name: "createdOn",
                label: "Feltöltés ideje",
                visibility: true,
                slot_name: "datetime_format"
            },
            {
                name: "loadedOn",
                label: "Betöltés ideje",
                sort: true,
                visibility: true,
                slot_name: "appointment_format"
            },
            {
                name: "deletedOn",
                label: "Törlés ideje",
                visibility: true,
                slot_name: "created_on_format"
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],


        logActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning mx-1",
                event_payload: 'backToXlsGrid'
            }
        ],
        logHeaderFields: [
            {
                name: "logText",
                label: "Betöltött Xls tartalma",
                visibility: true
            },
            {
                name: "createdOn",
                label: "Dátum",
                visibility: true,
                slot_name: "created_on_format"
            }
        ]
    }
}
